// CustomSnackbar.js
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";

const CustomSnackbar = ({ message, setMessage }) => {
  const handleClose = () => setMessage(null);
  const handleCopy = () => message && navigator.clipboard.writeText(message);

  return (
    <Snackbar
      open={Boolean(message)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={handleClose}
      autoHideDuration={null}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity="info"
        sx={{
          bgcolor: "background.paper",
          color: "text.primary",
          border: "1px solid",
          borderColor: "divider",
        }}
        action={
          <>
            {/* <Tooltip title="Copy">
              <IconButton size="small" onClick={handleCopy}>
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip> */}
            <Tooltip title="Close">
              <IconButton size="small" onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        }
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default CustomSnackbar;
